import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1097761255594088';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Helper to generate unique event ID
const generateEventId = (eventName: string) => {
  return `${eventName}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
};
// Anti-duplicate protection
let lastAddToCartTime = 0;
export const firePageView = () => {
  if (typeof window.fbq === 'function') {
    const eventId = generateEventId('PageView');
    window.fbq('track', 'PageView', {}, {
      eventID: eventId
    });
  }
};
export const fireViewContent = () => {
  if (typeof window.fbq === 'function') {
    const eventId = generateEventId('ViewContent');
    window.fbq('track', 'ViewContent', {
      content_name: 'Luxury Content System',
      content_category: 'Digital Product'
    }, {
      eventID: eventId
    });
  }
};
export const fireAddToCart = () => {
  const now = Date.now();
  if (now - lastAddToCartTime < 1000) return; // Prevent double firing within 1s
  lastAddToCartTime = now;
  if (typeof window.fbq === 'function') {
    const eventId = generateEventId('AddToCart');
    window.fbq('track', 'AddToCart', {
      value: 14.99,
      currency: 'USD',
      content_name: 'Luxury Content System'
    }, {
      eventID: eventId
    });
  }
};
export const fireInitiateCheckout = () => {
  if (typeof window.fbq === 'function') {
    const eventId = generateEventId('InitiateCheckout');
    window.fbq('track', 'InitiateCheckout', {
      value: 14.99,
      currency: 'USD'
    }, {
      eventID: eventId
    });
  }
};
export function MetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Fix: guard against missing script tags in React SPA environments
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', PIXEL_ID);
    // Fire initial events
    firePageView();
    fireViewContent();
  }, []);
  return null;
}